import Search from 'assets/icons/Search';
import { cn } from 'common/utils';
import React, { useState } from 'react';

export const SearchInput = ({
  height,
  inputWidth,
  placeholderText,
  handleChange,
  searchTerm = '',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const containerHeight = height ?? 'h-9';
  const openWidth = inputWidth ?? 'w-41';

  const openSearchBar = () => {
    setIsOpen(true);
  };

  const closeSearchBar = () => {
    if (!searchTerm && !isSelected) {
      setIsOpen(false);
    }
  };

  const handleInputFocus = () => {
    setIsSelected(true);
  };

  const handleInputBlur = () => {
    setIsSelected(false);
    if (!searchTerm) {
      setIsOpen(false);
    }
  };

  const handleInputChange = (e) => {
    handleChange && handleChange(e);
  };

  return (
    <div
      className={`relative transition-color duration-200 ${
        isOpen ? openWidth : 'aspect-square'
      } ${containerHeight} overflow-hidden border rounded-md ${
        isSelected ? 'border-dark-blue' : 'border-bright-grey'
      }`}
      onMouseEnter={openSearchBar}
      onMouseLeave={closeSearchBar}
    >
      {isOpen ? (
        <>
          <input
            className={cn(
              containerHeight,
              'w-full h-full pl-3 pr-8 rounded border-0 focus:outline-none',
              'placeholder:uppercase placeholder:opacity-80 text-dark-blue text-sm',
              isSelected
                ? 'placeholder:text-dark-blue'
                : 'placeholder:text-cool-gray',
            )}
            type='text'
            id='search'
            placeholder={placeholderText}
            onChange={handleInputChange}
            value={searchTerm}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
          />
          <div className='absolute top-0 right-0 h-full flex items-center pr-2.5'>
            <Search size='16px' color={isSelected ? '#084D6E' : '#8D91A0'} />
          </div>
        </>
      ) : (
        <div className='w-full h-full flex items-center justify-center'>
          <div className='grid place-items-center h-full w-12'>
            <Search size='16px' />
          </div>
        </div>
      )}
    </div>
  );
};
